export const INNER_WIDTH = {
    innerWidth: 861
  };